<template>
  <transition name="fade">
    <div id="class-starting-banner" class="class-starting-banner">
      <div class="class-starting-banner__text">
        Your {{ nearestClassStartTime | dateTimezone('h:mm A', profileTimezone) }} class is starting.
      </div>
      <a
        :href="nearestAvailableClass.streaming_host_url"
        target="_blank"
        class="class-starting-banner__join-link"
        id="class-starting-banner-join-link"
        >JOIN NOW!</a
      >
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

import { dateTimezone } from '@/utils/filters';

export default {
  name: 'ClassStartingBanner',

  filters: {
    dateTimezone,
  },

  computed: {
    ...mapGetters(['userProfile']),
    ...mapGetters('schedule', ['tutorId', 'nearestAvailableClass']),

    nearestClassStartTime() {
      const startOfJoiningWindow = new Date(this.nearestAvailableClass.join_time_min);
      return moment(startOfJoiningWindow).add(5, 'minutes');
    },

    profileTimezone() {
      if (!this.userProfile) {
        return null;
      }
      return this.userProfile.timezone;
    },
  },
};
</script>

<style lang="scss">
@import '~styles/tools/variables';

.class-starting-banner {
  position: relative;
  display: flex;
  padding: 1.5rem 0;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
  background: $default-green;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);

  &__join-link {
    margin-left: 0.75rem;
    border-bottom: 1px solid #fff;
  }

  &__close {
    font-size: 1.3em;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
</style>
